<script lang="ts" setup>
withDefaults(
  defineProps<{
    size?: 's' | 'm';
    dark?: boolean;
    classic?: boolean;
    dataTestId?: string;
  }>(),
  { size: 'm' },
);
const value = defineModel<boolean>('value', { default: () => false });
</script>

<template>
  <CheckboxRoot
    v-model="value"
    class="inputCheckingComponent"
    :class="{
      [`inputCheckingComponent_${size}`]: true,
      inputCheckingComponent_dark: dark,
      inputCheckingComponent_classic: classic,
    }"
    :data-test-id="dataTestId"
  >
    <CheckboxIndicator force-mount class="inputCheckingComponent__box">
      <SvgoSimpleCheck class="inputCheckingComponent__check" />
    </CheckboxIndicator>
  </CheckboxRoot>
</template>

<style lang="scss" src="@/assets/styles/input-checking.component.scss"></style>
